import { render, staticRenderFns } from "./PQuickLink.vue?vue&type=template&id=a162ef34&scoped=true"
import script from "./PQuickLink.vue?vue&type=script&lang=js"
export * from "./PQuickLink.vue?vue&type=script&lang=js"
import style0 from "./PQuickLink.vue?vue&type=style&index=0&id=a162ef34&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a162ef34",
  null
  
)

export default component.exports